<template>
  <div class="trading_operation">
    <div class="title_box">
      <div
        v-for="(item, index) of tradingTypes"
        :key="index"
        :class="{ activeTitle: currentTradingType === item.name }"
        class="each_title"
        @click="handleTradingType(item.name)"
      >
        <span>{{ item.title }}</span>
      </div>
    </div>

    <div class="operation_box">
      <!-- 买入操作 -->
      <div class="left_buy">
        <p :class="{ hiddenTipText: !isSignIn }" class="tip_text">
          <span>
            {{ $t('可用') }} {{ currentCoinBalance[1] || '---' }}
            {{ quoteCurrency }}
          </span>
          <span @click="handleRecharge(quoteCurrency)">
            {{ $t('充币') }}
          </span>
        </p>
        <!-- 限价买入价格框 -->
        <div v-if="currentTradingType === 'limit'" class="buy_input_box">
          <span class="buy_text">{{ $t('买入价') }}</span>
          <el-input
            v-model="buyPrice"
            type="text"
            slot="reference"
            @input="handleInput($event, 'buyPrice', 2)"
          >
            <span slot="suffix">{{ quoteCurrency }}</span>
          </el-input>
        </div>
        <!-- 市价买入价格框 -->
        <div v-else-if="currentTradingType === 'market'" class="buy_input_box">
          <span class="buy_text">{{ $t('买入价') }}</span>
          <p class="market">{{ $t('以当前最优价格买入') }}</p>
        </div>
        <!-- 限价、市价买入量 -->
        <div class="buy_input_box">
          <span class="buy_text">
            {{ currentTradingType === 'limit' ? $t('买入量') : $t('交易额') }}
          </span>
          <el-input
            v-model="inputBuyVolume"
            type="text"
            slot="reference"
            @input="handleInput($event, 'inputBuyVolume', 6)"
          >
            <span slot="suffix">
              {{
                currentTradingType === 'limit' ? baseCurrency : quoteCurrency
              }}
            </span>
          </el-input>
        </div>
        <div class="slider_box_buy">
          <el-slider
            v-model="buyPercent"
            :marks="marks"
            :format-tooltip="sliderBuyTips"
            :disabled="isBuySliderDisabled"
            @change="handleBuySlider"
            :class="{
              second_stop_active: buyTipNum > 25,
              third_stop_active: buyTipNum > 50,
              fourth_stop_active: buyTipNum > 75,
            }"
          ></el-slider>
        </div>
        <p
          :class="{ trading_total_hide: currentTradingType === 'market' }"
          class="trading_total"
        >
          <span>{{ $t('交易额') }}</span>
          <span>{{ buyTransactionAmount }} {{ quoteCurrency }}</span>
        </p>
        <!-- 未登录按钮 -->
        <el-button v-if="!isSignIn">
          <span @click="jumpTo('/signin')">{{ $t('登录') }}</span
          ><span> {{ $t('或') }} </span
          ><span @click="jumpTo('/register')">{{ $t('注册') }}</span>
        </el-button>
        <!-- 已登录按钮 -->
        <el-button
          v-else
          :loading="buyLoading"
          type="primary"
          @click="handleBuySell('buy')"
        >
          {{ $t('买入') }}
        </el-button>
      </div>

      <!-- 卖出操作 -->
      <div class="right_sell">
        <p :class="{ hiddenTipText: !isSignIn }" class="tip_text">
          <span
            >{{ $t('可用') }} {{ currentCoinBalance[0] || '---' }}
            {{ baseCurrency }}</span
          >
          <span @click="handleRecharge(baseCurrency)">{{ $t('充币') }}</span>
        </p>
        <!-- 限价卖出价格框 -->
        <div v-if="currentTradingType === 'limit'" class="buy_input_box">
          <span class="buy_text">{{ $t('卖出价') }}</span>
          <el-input
            v-model="sellPrice"
            type="text"
            slot="reference"
            @input="handleInput($event, 'sellPrice', 2)"
          >
            <span slot="suffix">{{ quoteCurrency }}</span>
          </el-input>
        </div>
        <!-- 市价卖出价格框 -->
        <div v-else-if="(currentTradingType = 'market')" class="buy_input_box">
          <span class="buy_text">{{ $t('卖出价') }}</span>
          <p class="market">{{ $t('以当前最优价格卖出') }}</p>
        </div>
        <!-- 限价、市价卖出量 -->
        <div class="buy_input_box">
          <span class="buy_text">{{ $t('卖出量') }}</span>
          <el-input
            v-model="inputSellVolume"
            type="text"
            slot="reference"
            @input="handleInput($event, 'inputSellVolume', 6)"
            @mousewheel.native.prevent
          >
            <span slot="suffix">{{ baseCurrency }}</span>
          </el-input>
        </div>
        <div class="slider_box_sell">
          <el-slider
            v-model="sellPercent"
            :marks="marks"
            :disabled="isSellSliderDisabled"
            :format-tooltip="sliderSellTips"
            @change="handleSellSlider"
            :class="{
              second_stop_active: sellTipNum > 25,
              third_stop_active: sellTipNum > 50,
              fourth_stop_active: sellTipNum > 75,
            }"
          ></el-slider>
        </div>
        <p
          :class="{ trading_total_hide: currentTradingType === 'market' }"
          class="trading_total"
        >
          <span>{{ $t('交易额') }}</span>
          <span>{{ sellTransactionAmount }} {{ quoteCurrency }}</span>
        </p>
        <!-- 未登录按钮 -->
        <el-button v-if="!isSignIn">
          <span @click="jumpTo('/signin')">{{ $t('登录') }}</span
          ><span> {{ $t('或') }} </span
          ><span @click="jumpTo('/register')">{{ $t('注册') }}</span>
        </el-button>
        <!-- 已登录按钮 -->
        <el-button
          v-else
          :loading="sellLoading"
          type="danger"
          @click="handleBuySell('sell')"
        >
          {{ $t('卖出') }}
        </el-button>
      </div>
    </div>

    <TradingPassDialog
      v-model="showTradingPassDialog"
      @trading="handleTrading"
    />
  </div>
</template>
<script>
import {
  tradingOperation,
  fetchTradingIsNeedPass,
  fetchPairTradeRules,
} from '@/api/transaction'
import EventBus from '@/utils/event-bus'
import { mapGetters, mapState } from 'vuex'
import TradingPassDialog from '../TradingPassDialog'
import { Big } from 'big.js'
import digitProcess from '@/mixin/digital-process'

export default {
  mixins: [digitProcess],
  components: {
    TradingPassDialog,
  },
  data() {
    return {
      tradingPairRule: null,
      side: '', // 下单方向 buy-买入；sell-卖出
      showTradingPassDialog: false,
      tradingTypes: [
        { title: this.$t('限价交易'), name: 'limit' },
        { title: this.$t('市价交易'), name: 'market' },
      ],
      currentTradingType: 'limit',
      buyPrice: '',
      sellPrice: '',
      inputBuyVolume: '', // 输入买入总量
      inputSellVolume: '', // 输入卖出总量
      buyPercent: 0,
      sellPercent: 0,
      buyTransactionAmount: 0, // 买入交易额
      sellTransactionAmount: 0, // 卖出交易额
      buyTipNum: 0,
      sellTipNum: 0,
      marks: {
        0: '',
        25: '',
        50: '',
        75: '',
        100: '',
      },
      buyLoading: false,
      sellLoading: false,
      buySellButtonStatus: true, // 买入卖出按钮默认初始状态：禁用
    }
  },
  computed: {
    ...mapState({
      tradingPairData: (state) => state.transaction.tradingPairData,
      currentCoinBalance: (state) => state.transaction.currentCoinBalance, // 当前币种余额
      handicapFirstPrice: (state) => state.transaction.handicapFirstPrice,
      userInfo: (state) => state.userInfo,
    }),
    ...mapGetters([
      'baseCurrency',
      'quoteCurrency',
      'tradingPairId',
      'tradingPair',
      'isSignIn',
      'lowerCaseBaseCurrency',
      'lowerCaseQuoteCurrency',
    ]),
    isSellSliderDisabled() {
      return (
        !+this.currentCoinBalance[0] ||
        (this.currentTradingType === 'limit' && !+this.sellPrice)
      )
    },
    isBuySliderDisabled() {
      return (
        !+this.currentCoinBalance[1] ||
        (this.currentTradingType === 'limit' && !+this.buyPrice)
      )
    },
  },
  mounted() {
    this.getCoinBalanceAndRule()
    this.getPairTradeRules(this.tradingPairId)
  },
  watch: {
    tradingPair() {
      this.initPercentVolumePopover()
      this.getCoinBalanceAndRule()
      this.getPairTradeRules(this.tradingPairId)
    },
    handicapFirstPrice(newVal) {
      this.buyPrice = newVal.sellFirstPrice
      this.sellPrice = newVal.buyFirstPrice
      this.handleInput(this.buyPrice, 'buyPrice', 2)
      this.handleInput(this.sellPrice, 'sellPrice', 2)
    },
    buyPrice(newVal) {
      this.calculateInput(
        newVal,
        this.inputBuyVolume,
        this.currentCoinBalance[1],
        (transactionAmount, percent) => {
          this.buyTransactionAmount = transactionAmount
          this.buyPercent = percent
        }
      )
    },
    sellPrice(newVal) {
      this.calculateInput(
        newVal,
        this.inputSellVolume,
        this.currentCoinBalance[0],
        (transactionAmount) => {
          this.sellTransactionAmount = transactionAmount
        }
      )
    },
    inputBuyVolume(newVal) {
      /* eslint-disable */
      switch (this.currentTradingType) {
        case 'limit':
          this.calculateInput(
            this.buyPrice,
            newVal,
            this.currentCoinBalance[1],
            (transactionAmount, percent) => {
              this.buyTransactionAmount = transactionAmount
              this.buyPercent = percent
            }
          )
          break
        case 'market':
          const availableAmount = this.currentCoinBalance[1] || 0
          this.buyPercent = this.calculatePercent(
            Big(newVal || 0),
            availableAmount
          )
          break
      }
      /* eslint-enable */
    },
    inputSellVolume(newVal) {
      const availableAmount = this.currentCoinBalance[0] || 0
      this.sellPercent = this.calculatePercent(
        Big(newVal || 0),
        availableAmount
      )
      /* eslint-disable */
      switch (this.currentTradingType) {
        case 'limit':
          this.calculateInput(
            this.sellPrice,
            newVal,
            this.currentCoinBalance[0],
            (transactionAmount, percent) => {
              this.sellTransactionAmount = transactionAmount
            }
          )
          break
      }
      /* eslint-enable */
    },
  },
  methods: {
    calculatePercent(transactionAmount, availableAmount) {
      if (!+availableAmount) {
        return 0
      }
      const percent = transactionAmount
        .div(availableAmount)
        .times(100)
        .toString()
      return +this.truncateDigit(percent)
    },
    calculateInput(price, amount, availableAmount, cb) {
      price = price || 0
      amount = amount || 0
      availableAmount = availableAmount || 0

      const transactionAmount = Big(price).times(amount)

      cb(
        this.truncateDigit(transactionAmount.toString()),
        this.calculatePercent(transactionAmount, availableAmount)
      )
    },
    getCoinBalanceAndRule() {
      // 每次点击切换新币种时，重新获取当前币种余额，并设置当前币种实际可用余额
      this.$store.dispatch('transaction/getTwoCoinBalance')
    },
    async getPairTradeRules(tradingPairId) {
      this.tradingPairRule = null
      const data = await fetchPairTradeRules({
        marketId: tradingPairId,
      })
      if (tradingPairId === this.tradingPairId) {
        this.tradingPairRule = data
      }
    },
    jumpTo(p, q) {
      this.$router.push({ path: p, query: q })
    },
    sliderBuyTips(val) {
      this.buyTipNum = val
      return val + '%'
    },
    sliderSellTips(val) {
      this.sellTipNum = val
      return val + '%'
    },
    // 点击切换交易类型
    handleTradingType(name) {
      this.currentTradingType = name
      this.initPercentVolumePopover()
    },
    handleBuySlider(numPercent) {
      /* eslint-disable */
      switch (this.currentTradingType) {
        case 'limit':
          this.inputBuyVolume = this.truncateDigit(
            Big(numPercent)
              .times(this.currentCoinBalance[1] || 0)
              .div(this.buyPrice)
              .div(100)
              .toString(),
            6
          )
          break
        case 'market':
          this.inputBuyVolume = this.truncateDigit(
            Big(numPercent)
              .times(this.currentCoinBalance[1] || 0)
              .div(100)
              .toString(),
            6
          )
          break
      }
      /* eslint-enable */
    },
    // ----------------------------------------------------------------------------------------------------------------------------不配置零什么原理
    handleSellSlider(numPercent) {
      this.inputSellVolume = this.truncateDigit(
        Big(numPercent)
          .times(this.currentCoinBalance[0] || 0)
          .div(100)
          .toString(),
        6
      )
    },
    // 处理买入卖出按钮加载状态
    dealBuySellLoading(direction, boolean) {
      switch (direction) {
        case 'buy':
          this.buyLoading = boolean
          break
        case 'sell':
          this.sellLoading = boolean
          break
      }
    },
    // 重置买入卖出拖动条、买入卖出量
    initPercentVolumePopover() {
      this.buyPercent = 0
      this.sellPercent = 0
      this.inputBuyVolume = ''
      this.inputSellVolume = ''
    },
    validate() {
      const availableAmount =
        this.side === 'buy'
          ? this.currentCoinBalance[1]
          : this.currentCoinBalance[0]

      const price = this.side === 'buy' ? this.buyPrice : this.sellPrice
      const amount =
        this.side === 'buy' ? this.inputBuyVolume : this.inputSellVolume

      if (this.currentTradingType === 'limit') {
        if (!+price) {
          const priceText =
            this.side === 'buy' ? this.$t('买入价') : this.$t('卖出价')
          this.$Message.warning(this.$t('请输入') + priceText)
          return false
        }
      }

      if (!+amount) {
        const amountText =
          this.side === 'buy'
            ? this.currentTradingType === 'limit'
              ? this.$t('买入量')
              : this.$t('交易额')
            : this.$t('卖出量')
        this.$Message.warning(this.$t('请输入') + amountText)
        return false
      }

      const transactionAmount =
        this.currentTradingType === 'limit'
          ? this.side === 'buy'
            ? Big(price).times(amount)
            : Big(amount)
          : Big(amount)

      if (!+availableAmount || transactionAmount.gt(availableAmount)) {
        const token =
          this.side !== 'buy' ? this.baseCurrency : this.quoteCurrency
        this.$Message.warning(this.$t('可用不足', { token }))
        return false
      }
      return true
    },
    handleRecharge(coinName) {
      if (this.userInfo.c1Status === 'Yes') {
        this.jumpTo('/recharge', { coinName })
      } else {
        this.$Modal.confirm({
          title: this.$t('未完成必要的认证'),
          okText: this.$t('去认证'),
          cancelText: this.$t('取消'),
          onOk: () => {
            this.$router.push({ path: '/notcertified/recharge' })
          },
        })
      }
    },
    /**
     * @description 点击买入卖出操作
     * @params side 下单方向 buy-买入；sell-卖出
     */
    async handleBuySell(side) {
      this.side = side

      const { c1Status, c2Status, isTrade } = this.userInfo
      if (
        ((side === 'buy' && c1Status === 'Yes') ||
          (side === 'sell' && c2Status === 'Yes')) &&
        isTrade === 1
      ) {
        // 检测买入卖出输入框的值
        if (!this.validate()) return

        const isNeedPass = await fetchTradingIsNeedPass()
        if (isNeedPass) {
          this.showTradingPassDialog = true
        } else {
          this.handleTrading()
        }
      } else {
        this.$Modal.confirm({
          title: this.$t('未完成必要的认证'),
          okText: this.$t('去认证'),
          cancelText: this.$t('取消'),
          onOk: () => {
            this.$router.push({ path: `/notcertified/${side}` })
          },
        })
      }
    },
    async handleTrading(password) {
      const params = {
        marketId: this.tradingPairData.marketId,
        source: 'web',
        side: this.side,
        type: this.currentTradingType,
      }

      const amount =
        this.side === 'buy' ? this.inputBuyVolume : this.inputSellVolume

      const isBuy = this.side === 'buy'
      const isSell = this.side === 'sell'
      if (this.currentTradingType === 'limit') {
        params.price = this.side === 'buy' ? this.buyPrice : this.sellPrice
        params.num = amount
      }
      if (this.currentTradingType === 'market') {
        if (isSell) {
          params.num = amount
        }
        if (isBuy) {
          params.notional = amount
        }
      }

      if (password) {
        params.password = password
        this.showTradingPassDialog = false
      }

      this.dealBuySellLoading(this.side, true)
      try {
        await tradingOperation(params)

        this.$Message.success(this.$t('操作成功'))
        this.dealBuySellLoading(this.side, false)
        this.initPercentVolumePopover()
        EventBus.$emit('getCurrentTransaction') // 买入卖出成功后获取最新历史委托数据
        this.$store.dispatch('transaction/getTwoCoinBalance')
      } catch {
        this.dealBuySellLoading(this.side, false)
        this.initPercentVolumePopover()
      }
    },
  },
}
</script>
<style lang="less" scoped>
.trading_operation {
  min-width: 668px;
  .title_box {
    padding: 12px 20px 0 20px;
    background: @titleBgColor1;
    .each_title {
      margin-right: 20px;
      display: inline-block;
      cursor: pointer;
      span {
        font-size: 16px;
        font-family: PingFangSC-Medium, 'PingFang SC';
        font-weight: 500;
        color: @textColor5;
        line-height: 22px;
      }
      p {
        margin-top: 5px;
        height: 2px;
      }
    }
    // 动态控制活跃交易类型样式
    .activeTitle {
      span {
        color: @textColor4;
      }
      p {
        background-color: rgba(66, 179, 250, 1);
      }
    }
  }
  .operation_box {
    padding: 0 30px;
    display: flex;
    flex-direction: row;
    background: @contentBgColor3;
    .left_buy,
    .right_sell {
      padding: 10px 30px 15px 0;
      border-right: 1px solid #979797;
      flex-grow: 1;
      .tip_text {
        height: 17px;
        line-height: 17px;
        overflow: hidden;
        span {
          font-size: 12px;
          font-weight: 400;
          color: @textColor6;
        }
        span:last-child {
          float: right;
          color: rgba(66, 179, 250, 1);
          cursor: pointer;
        }
      }
      // 动态显示隐藏可用余额/充值
      .hiddenTipText {
        visibility: hidden;
      }
      .buy_input_box {
        margin-top: 10px;
        display: flex;
        flex-direction: row;
        align-items: center;
        .buy_text {
          flex-shrink: 0;
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          color: @textColor6;
          line-height: 20px;
        }
        .market {
          padding: 5px 10px;
          height: 30px;
          flex-grow: 1;
          background: @inputBgColor;
          border-radius: 2px;
          font-weight: 400;
          color: #aab2d4;
          line-height: 20px;
          user-select: none;
        }
        span:nth-child(2) {
          flex-grow: 1;
        }
      }
      .slider_box_buy,
      .slider_box_sell {
        padding: 0 6px 0 6px;
      }
      .trading_total {
        margin-bottom: 10px;
        span:first-child {
          margin-right: 10px;
          font-size: 14px;
          font-weight: 400;
          color: @textColor7;
          line-height: 20px;
        }
        span:last-child {
          font-size: 14px;
          font-weight: 400;
          color: @textColor8;
          line-height: 20px;
        }
      }
      // 动态控制交易额隐藏
      .trading_total_hide {
        visibility: hidden;
      }
    }
    .right_sell {
      padding: 10px 0 15px 30px;
      border-right: none;
    }
  }
}
</style>
